import { loadData } from "../Common/Template";
import { logSystemError } from "../../modules/SystemErrorService";
import {
    getEndTimeDisplayWithGMTOffset,
    createTimeDisplayInfoForTimeZone
} from "../../modules/TimeService";
import { jsonParse } from "..";
import { companyProviderRestrictionConfigAtom } from "../../atoms/atoms";

export const ProviderBookingConfirmation = async ({
    provider,
    client,
    company,
    serviceType,
    bookings,
    orderNo,
    orderType,
    orderNotes,
    wdDisplay
}) => {
    const providerRestrictionConfig = jsonParse(
        company?.ProviderRestrictionConfig,
        {
            canProviderSeeClientName: true,
            canProviderSeeClientEmail: false,
            canProviderSeeClientPhone: true
        }
    );

    const adjustedBookings = bookings.map(
        ({ TimeDisplayInfo, minutes, ...rest }) => {
            const parsedTimeDisplayInfo =
                typeof TimeDisplayInfo === "string"
                    ? JSON.parse(TimeDisplayInfo)
                    : TimeDisplayInfo;

            return {
                ...rest,
                TimeDisplayInfo: provider.timezone
                    ? createTimeDisplayInfoForTimeZone(
                          parsedTimeDisplayInfo.dtstamp_str,
                          provider.timezone,
                          minutes
                      )
                    : parsedTimeDisplayInfo
            };
        }
    );
    try {
        let htmlTemplate = await loadData(
            `https://do1e1nd2rp5b.cloudfront.net/public/email-templates/${company.id}/order-receipt-provider-tokenized.html`,
            company.id
        );

        // check if we got a template, if not load a generic template
        if (htmlTemplate === "Error") {
            // load generic template
            htmlTemplate = await loadData(
                "https://do1e1nd2rp5b.cloudfront.net/public/email-templates/modified-templates/order-receipt-provider-tokenized.html",
                company.id
            );
        }
        // if still an error, we have a network problem
        if (htmlTemplate === "Error") {
            return "";
        }

        //NEW TOKEN REPLACEMENT
        htmlTemplate = htmlTemplate.replace(
            /\[company-auth-site-url\]/g,
            process.env.REACT_APP_AUTH_SITE_URL
        );
        htmlTemplate = htmlTemplate.replace(
            /\[company-logo-url\]/g,
            company.logoUrl
        );
        htmlTemplate = htmlTemplate.replace(
            /\[company-color\]/g,
            company.primaryColor
        );
        htmlTemplate = htmlTemplate.replace(/\[company_name\]/g, company.name);
        htmlTemplate = htmlTemplate.replace(
            /\[company_email\]/g,
            company.emailaddress
        );
        htmlTemplate = htmlTemplate.replace(
            /\[provider_firstname\]/g,
            provider.firstname
        );
        htmlTemplate = htmlTemplate.replace(
            /\[provider_lastname\]/g,
            provider.lastname
        );

        const clientName = providerRestrictionConfig.canProviderSeeClientName
            ? client.user.firstname + " " + client.user.lastname
            : client.user.firstname +
              " " +
              client.user.lastname.charAt(0) +
              ".";
        htmlTemplate = htmlTemplate.replace(/\[client_name\]/g, clientName);
        htmlTemplate = htmlTemplate.replace(/\[order_no\]/g, orderNo);
        htmlTemplate = htmlTemplate.replace(
            /\[booking_location\]/g,
            adjustedBookings[0].isVirtual
                ? !adjustedBookings[0].provider.vmlink
                    ? "Virtual Appointment"
                    : `Virtual Appointment - Join here: ${adjustedBookings[0].provider.vmlink}`
                : adjustedBookings[0].location
        );
        htmlTemplate = htmlTemplate.replace(
            /\[client_phone\]/g,
            getClientPhone(
                client.user,
                providerRestrictionConfig.canProviderSeeClientPhone
            )
        );
        htmlTemplate = htmlTemplate.replace(
            /\[servicetype_name\]/g,
            serviceType.name
        );
        htmlTemplate = htmlTemplate.replace(
            /\[booking_date\]/g,
            adjustedBookings[0].TimeDisplayInfo.dt_long_disp
        );
        htmlTemplate = htmlTemplate.replace(
            /\[booking_time\]/g,
            `${adjustedBookings[0].TimeDisplayInfo.tm_st_disp} (${adjustedBookings[0].TimeDisplayInfo.tz_abbr_disp})`
        );
        htmlTemplate = htmlTemplate.replace(
            /\[end_time\]/g,
            `${getEndTimeDisplayWithGMTOffset(
                adjustedBookings[0].TimeDisplayInfo
            )}`
        );

        //Doesn't need global replacement, iterates on itself.
        let packageSection = "";
        // pacakge section if more than one booking
        if (adjustedBookings.length > 1) {
            packageSection = `  <tr>
                                  <td width="70%">
                                      <b>Additional bookings are confirmed for the following date(s) and time(s):</b>
                                  </td>
                              </tr>
                              <tr>
                                  <td width="70%">
                                      &nbsp; 
                                  </td>
                              </tr>`;
            for (let i = 1; i < adjustedBookings.length; i++) {
                let bookingRow = `   <tr>
                                  <td width="70%">
                                      <b>Date:</b> [booking_date]
                                  </td>
                              </tr>
                              <tr>
                                  <td width="70%">
                                      <b>Time:</b> [booking_time] to [end_time]
                                  </td>
                                  </tr>
                              <tr>
                                  <td width="70%">
                                      &nbsp; 
                                  </td>
                              </tr>`;
                bookingRow = bookingRow.replace(
                    "[booking_date]",
                    adjustedBookings[i].TimeDisplayInfo.dt_long_disp
                );
                bookingRow = bookingRow.replace(
                    "[booking_time]",
                    `${adjustedBookings[i].TimeDisplayInfo.tm_st_disp} (${adjustedBookings[i].TimeDisplayInfo.tz_abbr_disp})`
                );
                bookingRow = bookingRow.replace(
                    "[end_time]",
                    `${getEndTimeDisplayWithGMTOffset(
                        adjustedBookings[i].TimeDisplayInfo
                    )}`
                );
                packageSection += bookingRow;
            }
        }

        if (orderType === "ONGOING" && wdDisplay) {
            packageSection = `  <tr>
              <td width="70%">
                  <strong>Repeats: </strong> Every <b>${wdDisplay}</b>, starting ${adjustedBookings[0].TimeDisplayInfo.dt_long_disp}
              </td>
            </tr>
            <tr>
              <td width="70%">
                  &nbsp; 
              </td>
        </tr>`;
        }
        htmlTemplate = htmlTemplate.replace(
            /\[additional_bookings\]/g,
            packageSection
        );
        htmlTemplate = htmlTemplate.replace(/\[notes\]/g, orderNotes);

        return htmlTemplate;
    } catch (err) {
        await logSystemError(
            company.id,
            "ERROR",
            "Error populating provider order-booking receipt template",
            0,
            err
        );
    }
    return "";
};

function getClientPhone(user, canProviderSeeClientPhone) {
    if (canProviderSeeClientPhone) {
        if (user.phonepref === "MOBILE") {
            if (user.mobilephone) return user.mobilephone;
            else {
                if (user.homephone) return user.homephone;
                if (user.workphone) return user.workphone;
            }
        }
        if (user.phonepref === "HOME") {
            if (user.homephone) return user.homephone;
            else {
                if (user.mobilephone) return user.mobilephone;
                if (user.workphone) return user.workphone;
            }
        }
        if (user.phonepref === "WORK") {
            if (user.workphone) return user.workphone;
            else {
                if (user.mobilephone) return user.mobilephone;
                if (user.homephone) return user.homephone;
            }
        }
        if (user.mobilephone) return user.mobilephone;
        if (user.homephone) return user.homephone;
        if (user.workphone) return user.workphone;

        return "";
    } else {
        return "(***) *** - ****";
    }
}
